import './css/styles.scss';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const FancyInit = function() {
		 // Hämta samtliga gallerier. 
        // Du kan byta ut .wp-block-gallery mot .femp-gallery-block om du föredrar.
        const galleries = document.querySelectorAll('.wp-block-gallery');

        // Avbryt om inga gallerier finns
        if (!galleries.length) {
            return;
        }

        // Loopar igenom varje galleri
        galleries.forEach((gallery, index) => {
            // Skapa ett unikt data-fancybox-värde
            const groupName = `galleri-${index}`;

            // Hitta alla länkar i just detta galleri som pekar på bildfiler
            const links = gallery.querySelectorAll(
                'a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"], a[href*=".webp"]'
            );

            // Sätt data-fancybox och eventuellt data-caption för varje länk
            links.forEach((link) => {
                link.setAttribute('data-fancybox', groupName);

                const figcaption = link.parentNode.querySelector('figcaption');
                if (figcaption) {
                    link.setAttribute('data-caption', figcaption.textContent);
                }
            });
        });

        // Nu binder vi Fancybox till alla element som har data-fancybox
        Fancybox.bind('[data-fancybox]', {
            // Behåll scrollbaren synlig (om du vill)
            hideScrollbar: false,

            // Inaktivera "dra-för-att-stänga" på mobiler
            dragToClose: false,

            // Visa nära-knappen
            closeButton: true,

            // Inaktivera toolbar
            Toolbar: false,

            // Zooma inte, och stäng vid klick eller scrollhjul
            Image: {
                zoom: false,
                click: 'close',
                wheel: 'close',
            },

            // Anpassade animationer
            showClass: 'fancybox-zoomIn',
            hideClass: 'fancybox-zoomOut',
		});
};

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	FancyInit();
});

